interface ISlideHelpText {
    desktopText: string;
    mobileText: string;
}

export const slideHelpText: ISlideHelpText = {
    desktopText: `Sleep de slider net zover naar rechts totdat de vogel
    <strong>nog net zichtbaar blijft.</strong>`,
    mobileText: 'Sleep de slider totdat de vogel nog net zichtbaar is.',
};
